// export const BASE_URL: string = "https://api.misaletech.org";
export const BASE_URL: string = "https://directoryapi.ashewa.com";
